// types for the network points service (*only* backend)
// see https://gitlab.com/prisma-capacity/platform/networkpoint/-/blob/main/src/main/resources/open-api.yml
import { Links, OptionalLinks } from 'src/types/api-utilities';

export type NetworkPointsRootResponse = {
  _links: Links<'getNetworkPoints'> & OptionalLinks<'getNumberOfFavourites'>;
};

export enum ActiveNetworkPointFilter {
  ACTIVE = 'ACTIVE', // Only return network points that are active
  ACTIVE_AND_OWN_AND_PREVIOUSLY_ACTIVE = 'ACTIVE_AND_OWN_AND_PREVIOUSLY_ACTIVE', // All network points that are active, plus all own network points (no matter if active or not), plus all inactive network points, that had been active earlier.
  ACTIVE_AND_PREVIOUSLY_ACTIVE = 'ACTIVE_AND_PREVIOUSLY_ACTIVE', // All network points that are active, plus all inactive network points, that had been active earlier.
  INACTIVE_BUT_PREVIOUSLY_ACTIVE_AND_OWN_INACTIVE = 'INACTIVE_BUT_PREVIOUSLY_ACTIVE_AND_OWN_INACTIVE', // All own inactive ones, PLUS all inactive ones from other TSOs that had been active before.
  INACTIVE_BUT_PREVIOUSLY_ACTIVE = 'INACTIVE_BUT_PREVIOUSLY_ACTIVE', // all inactive ones that have been active before.',
}

export type NetworkPointsParams = {
  q?: string | null; // The term to use for the search
  offset?: number | null;
  limit?: number | null;
  favouritesAboveIfInitialSearch?: boolean | null; //  If we have an initial search, and this parameter is set to true (and the user has a  shipper role), we reorder the result list and put the favourite network points on top. Otherwise, we would just return all network points in alphabetical order.
  onlyFavourites?: boolean | null; // Only return own favorite points for Shippers
  onlyOwn?: boolean | null; // Only return own network points. If not a TSO, result list will be empty.
  active?: ActiveNetworkPointFilter | null;
};

export type NumberOfFavouritesResponse = {
  _links: Links<'self'>;
  size: number;
};

export type NetworkPointsResponse = {
  total: number;
  offset: number;
  limit: number;
  _embedded: {
    items: NetworkPoint[];
  };
};

export type NetworkPoint = {
  id: string;
  name: string;
  identifier: string;
  favourite: boolean;
  score?: number;
  active: boolean;
} & (
  | {
      bundle: false;
      marketer: string; // short name
      marketerId: string;
      marketArea: string;
      direction: FlowDirection;
    }
  | {
      bundle: true;
      exit: DirectionMeta;
      entry: DirectionMeta;
    }
);

export type FlowDirection = 'EXIT' | 'ENTRY';

export type DirectionMeta = {
  marketer: string; // short name
  marketerId: string;
  marketArea: string;
};
